export const hex2rgba = (hex, alpha = 1, noTransparency = false) => {
    const hexMatch = hex.match(/\w\w/g);
    const [r, g, b] = hexMatch ? hexMatch.map((x) => parseInt(x, 16)) : [0, 0, 0];
    return noTransparency ? `rgb(${r},${g},${b})` : `rgba(${r},${g},${b},${alpha})`;
};
